export default __webpack_public_path__ + "static/media/811.5a181f41.gif";